import { ReactNode } from 'react';

export interface ITooltipProps {
  children: ReactNode;
  className?: string;
  color?: 'black' | 'magenta';
  withArrow?: boolean;
  arrowType?: 'up' | 'down';
  arrowClassName?: string;
}

export enum TooltipColors {
  black = 'black',
  magenta = 'magenta',
}
